import "./banner.scss";

const BannerPolicy = () => {
  return (
    <section className="banner-policy">
      <div className="banner_container container-xxl">
        <div className="content">
          <h1 className="title">Chính Sách Bảo Mật</h1>
        </div>
        <div className="banner_img">
          <img
            src={require("../../assets/image/privacyPolicy/banner_image.webp")}
            width={640}
            height={586}
            alt="banner_image"
          />
        </div>
      </div>
    </section>
  );
};

export default BannerPolicy;
